export default function NGagePrivacyPolicy() {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto", textAlign: "left" }}>
      <h1>Privacy Policy for Switch N-Gage</h1>

      <p>
        <strong>Last Updated:</strong> 07 July 2026
      </p>

      <p>
       Switch N-Gage respects your privacy. This Privacy Policy explains how we
        collect, use, and protect information when you use the Switch N-Gage mobile
        application. The application is intended solely for authorized employees
        of our organization.
      </p>

      <h2>1. Purpose of the Application</h2>

      <p>
       Switch N-Gage is an employee engagement platform designed to manage company
        events, games, activities, rewards, and employee participation. Through
        the application, employees can view their points, pillar points,
        rankings, and event-related information.
      </p>

      <h2>2. Information We Collect</h2>

      <h3>2.1 Employee Information</h3>

      <p>
        User accounts are created and managed by the organization. Employees
        cannot register or create accounts on their own.
      </p>

      <ul>
        <li>Employee Name</li>
        <li>Employee ID</li>
        <li>Official Mobile Number</li>
        <li>Official Email Address</li>
        <li>Department or Team Information</li>
      </ul>

      <h3>2.2 Activity Information</h3>

      <p>
        To provide engagement and participation features, we may collect:
      </p>

      <ul>
        <li>Event participation records</li>
        <li>Game participation records</li>
        <li>Points earned through activities</li>
        <li>Pillar points and achievement data</li>
        <li>Leaderboard and ranking information</li>
      </ul>

      <h2>3. How We Use Information</h2>

      <ul>
        <li>To provide secure employee access to the application</li>
        <li>To display event and game participation details</li>
        <li>To calculate and display employee points</li>
        <li>To display pillar points and achievements</li>
        <li>To maintain leaderboards and rankings</li>
        <li>To improve employee engagement programs</li>
        <li>To ensure proper operation of the application</li>
      </ul>

      <h2>4. Permissions Used</h2>

      <h3>Internet Permission</h3>

      <p>
        Internet access is required to authenticate users, retrieve employee
        information, synchronize event participation data, and display points
        and rankings.
      </p>

      <h2>5. Data Security</h2>

      <p>
        We implement reasonable security measures to protect employee
        information. Access to the application is restricted to authorized
        employees only. User authentication and secure communication methods are
        used to help prevent unauthorized access.
      </p>

      <p>
        Where applicable, additional security features such as PIN protection or
        App Lock may be used to further secure access to employee information.
      </p>

      <h2>6. Data Sharing</h2>

      <p>
        Employee information and participation data are used only for internal
        business purposes. We do not sell, rent, or share personal information
        with external third parties except when required by law.
      </p>

      <h2>7. Data Retention</h2>

      <p>
        Employee information and activity records may be retained as required
        for business operations, reporting, recognition programs, and compliance
        purposes.
      </p>

      <h2>8. Employee Rights</h2>

      <p>
        Employees may contact the organization regarding questions about their
        account information, points, or participation records.
      </p>

      <h2>9. Children's Privacy</h2>

      <p>
        N-Gage is intended solely for company employees and is not designed for
        use by children under the age of 13.
      </p>

      <h2>10. Changes to This Privacy Policy</h2>

      <p>
        We may update this Privacy Policy periodically. Any changes will be
        posted within the application along with the updated effective date.
      </p>

      <h2>11. Contact Us</h2>

       <p>
        <strong>Email:</strong> itconnect@switchmobilityev.com
        <br />
        <strong>Developer/Company Name:</strong> Switch Mobility Ltd
      </p>
    </div>
  );
}